/* eslint-disable react/no-did-update-set-state */
import React from 'react'
import _ from 'lodash'
import firebase from 'firebase/app'
import { connect } from 'react-redux'
import moment from 'moment'
import { Segment, Icon, Button, Header, Form, Modal, Checkbox } from 'semantic-ui-react'

import ChoiceForm from '../../promotions/forms/choiceForm'
import RestaurantsField from '../../promotions/fields/restaurantField'
import BranchesField from '../../promotions/fields/branchesField'
import DateField from '../../promotions/fields/dateField'
import DiscountField from '../../promotions/fields/discountField'
import MinimumAmountField from '../../promotions/fields/minimumAmountField'
import InputField from '../../promotions/fields/inputField'
import ItemField from '../../promotions/fields/itemsField'
import ShareExpense from '../../promotions/fields/shareExpense'
import ItemActions from '../../../reducers/itemReducer'
import PickUpPromotionActions from '../../../reducers/pickUpPromotionReducer'

// eslint-disable-next-line react/no-redundant-should-component-update
class PromotionForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    saving: false,
    discountRate: 0,
    startAt: Date.now(),
    endAt: Date.now(),
    companyRate: 0,
    merchantRate: 0,
    selectedItems: [],
    selectedMerchant: null,
    selectedBranch: null,
    isCostSharing: false,
    isSelectedItems: false,
    isApplyToAllBranches: false,
    isDiscountOnItem: false,
    messageEn: '',
    messageKh: '',
    minimumAmount: 0,
    choices: [],
  }

  componentDidMount() {
    const { action, promotionData } = this.props

    if (action === 'edit') {
      const customDiscountItem = _.reduce(
        promotionData.custom,
        (result, custom) => {
          custom.item_ids.forEach(itemKey => {
            const discountRate = custom.discount_rate
            // eslint-disable-next-line no-param-reassign
            result.push({ itemKey, discountRate })
          })

          return result
        },
        []
      )

      this.setState({
        discountRate: promotionData.discount_rate,
        startAt: promotionData.started_at || Date.now(),
        endAt: promotionData.ended_at || Date.now(),
        companyRate: _.get(promotionData, 'cost_sharing.company', 0),
        merchantRate: _.get(promotionData, 'cost_sharing.merchant', 0),
        selectedItems: promotionData.selected_items || [],
        selectedMerchant: promotionData.merchant_id,
        selectedBranch: promotionData.branch_id,
        isCostSharing: !!promotionData.cost_sharing,
        isSelectedItems: (promotionData.selected_items || []).length > 0,
        isDiscountOnItem: !!promotionData.custom,
        choices: customDiscountItem,
        minimumAmount: promotionData.minimum_amount || 0,
        messageEn: promotionData.message_en || '',
        messageKh: promotionData.message_kh || '',
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      selectedMerchant: prevSelectedMerchant,
      isSelectedItems: prevIsSelectedItems,
      isDiscountOnItem: prevIsDiscountOnItem,
    } = prevState
    const { isDiscountOnItem, isSelectedItems, selectedMerchant } = this.state
    const { action, fetchItems } = this.props

    if (action === 'new' && prevSelectedMerchant !== selectedMerchant) {
      this.setState(
        { isSelectedItems: false, selectedItems: [], choices: [], isDiscountOnItem: false },
        () => {
          fetchItems(selectedMerchant)
        }
      )
    }

    if (prevIsSelectedItems !== isSelectedItems && !isSelectedItems) {
      this.setState({ isDiscountOnItem: false, selectedItems: [] })
    }

    if (prevIsDiscountOnItem !== isDiscountOnItem && !isDiscountOnItem) {
      this.setState({ choices: [] })
    }
  }

  onItemsChange = data => {
    const value = data.map(d => d.value)

    this.setState({ selectedItems: value })
  }

  onShareExpenseCheck = () => {
    const { isCostSharing, discountRate } = this.state
    let shareExpense = {}

    if (!isCostSharing) {
      const shareRate = Number(parseFloat(discountRate / 2).toFixed(2))

      shareExpense = {
        companyRate: shareRate,
        merchantRate: shareRate,
      }
    }

    this.setState({ isCostSharing: !isCostSharing, ...shareExpense })
  }

  onSharingExpenseChange = (field, value) => {
    const { discountRate } = this.state

    const otherCostSharingField = field === 'merchantRate' ? 'companyRate' : 'merchantRate'
    const formattedValue = Number(value)


    const { merchantRate, companyRate } = {
      [field]: formattedValue,
      [otherCostSharingField]: Number(parseFloat(discountRate - formattedValue).toFixed(2))
    }

    this.setState({ merchantRate, companyRate  })
  }

  listSelectedMerchantBranches = () => {
    const { selectedMerchant } = this.state
    const { restaurants } = this.props

    const restaurant = restaurants[selectedMerchant] || {}

    return _.reduce(
      restaurant.branches,
      (result, branch, branchKey) => {
        result.push({
          ...branch,
          key: branchKey,
        })

        return result
      },
      []
    )
  }

  listSelectedItems = () => {
    const { selectedMerchant, selectedItems } = this.state
    const { items } = this.props
    const selectedMerchantItems = items[selectedMerchant]

    return _.reduce(
      selectedMerchantItems,
      (result, item, key) => {
        const option = {
          label: item.name,
          value: key,
        }

        if (selectedItems.includes(key)) {
          result.existedValue.push(option)
        }

        result.options.push(option)

        return result
      },
      { existedValue: [], options: [] }
    )
  }

  generateCustomItems = () => {
    const { choices } = this.state

    return _.chain(choices)
      .orderBy(['discountRate'], ['desc'])
      .uniqBy('itemKey')
      .groupBy('discountRate')
      .map((items, eachDiscountRate) => {
        const eachDiscount = {
          discount_rate: Number(eachDiscountRate),
          item_ids: _.map(items, 'itemKey'),
        }

        return eachDiscount
      })
      .value()
  }

  validateFields = async () => {
    const {
      endAt,
      startAt,
      choices,
      discountRate,
      selectedItems,
      selectedBranch,
      isSelectedItems,
      selectedMerchant,
      isDiscountOnItem,
      isApplyToAllBranches,
      messageEn,
      messageKh,
      isCostSharing,
      merchantRate,
      companyRate,
    } = this.state

    if (!selectedMerchant) {
      throw new Error('Please select Merchant.')
    }

    if (!selectedBranch && !isApplyToAllBranches) {
      throw new Error('Please select Branch.')
    }

    if (!startAt || !endAt || endAt < startAt) {
      throw new Error('Invalid Date Range.')
    }

    if (discountRate === 0) {
      throw new Error('Discount Rate must be greater than 0.')
    }

    if (isSelectedItems && selectedItems.length === 0) {
      throw new Error('Please select at lease one item.')
    }

    if (isDiscountOnItem && choices.length === 0) {
      throw new Error('Please choose at lease one custom item.')
    }

    if (isDiscountOnItem && choices.length > 0) {
      const hasInvalidItem = _.some(choices, choice => !choice.itemKey || Number(choice.discountRate) === 0)

      if (hasInvalidItem) {
        throw new Error('Please select custom item.')
      }
    }

    if (!messageEn) {
      throw new Error('Please input the message.')
    }
    if (!messageKh) {
      throw new Error('Please input the message.')
    }

    if (isCostSharing && (merchantRate + companyRate !== discountRate))
      throw new Error('Cost Sharing is invalid.')

    return true
  }

  onSavePress = async () => {
    const { action } = this.props
    const { isApplyToAllBranches } = this.state

    try {
      await this.validateFields()

      if (action === 'edit' || (action === 'new' && !isApplyToAllBranches)) {
        return this.upsertPromotion()
      }

      if (action === 'new' && isApplyToAllBranches) {
        return this.upsertAllBranches()
      }

      return false
    } catch (error) {
      return alert(error.message || error)
    }
  }

  upsertAllBranches = async () => {
    try {
      const {
        endAt,
        startAt,
        choices,
        companyRate,
        merchantRate,
        discountRate,
        isCostSharing,
        selectedItems,
        isSelectedItems,
        isDiscountOnItem,
        selectedMerchant,
        minimumAmount,
        messageEn,
        messageKh,
      } = this.state

      const { onClose, savePromotion, authData, restaurants, promotions } = this.props

      this.setState({ saving: true })

      const promotionRef = firebase.firestore().collection('pick_up_discount_promotions')
      const batches = firebase.firestore().batch()

      const merchant = restaurants[selectedMerchant]

      const allPromotionBranch = _.map(promotions, promo => promo.branch_id)
      const merchantBranches = this.listSelectedMerchantBranches()
      const promotionsToInsert = []

      merchantBranches.forEach(branch => {
        if (!allPromotionBranch.includes(branch.key)) {
          const docRef = promotionRef.doc()

          const data = {
            merchant_id: selectedMerchant,
            merchant_name: _.get(merchant, 'name', 'N/A'),
            branch_id: branch.key,
            branch_name: _.get(merchant, ['branches', branch.key, 'name'], 'N/A'),
            started_at: Number(startAt),
            ended_at: Number(endAt),
            discount_rate: Number(discountRate),
            region: authData.region,
            message_en: messageEn,
            message_kh: messageKh,
            minimum_amount: minimumAmount,
            ...(isCostSharing ? { cost_sharing: { company: companyRate, merchant: merchantRate } } : {}),
            ...(isSelectedItems && selectedItems.length > 0 ? { selected_items: selectedItems } : {}),
            ...(isSelectedItems && selectedItems.length > 0 && isDiscountOnItem && choices.length > 0
              ? { custom: this.generateCustomItems() }
              : {}),
          }

          promotionsToInsert.push({ ...data, key: docRef.id })
          batches.set(docRef, data)
        }
      })

      await batches.commit()

      promotionsToInsert.forEach(promotion => {
        savePromotion(promotion)
      })

      onClose()
      this.setState({ saving: false })
    } catch (error) {
      this.setState({ saving: false })
      alert(error.message || error)
    }
  }

  upsertPromotion = async () => {
    try {
      const {
        endAt,
        startAt,
        choices,
        companyRate,
        merchantRate,
        discountRate,
        isCostSharing,
        selectedItems,
        selectedBranch,
        isSelectedItems,
        isDiscountOnItem,
        selectedMerchant,
        minimumAmount,
        messageEn,
        messageKh,
      } = this.state

      this.setState({ saving: true })

      const { savePromotion, action, onClose, promotionData, authData, restaurants } = this.props

      const promotionRef = firebase.firestore().collection('pick_up_discount_promotions')
      const promotionKey = (promotionData && promotionData.key) || promotionRef.doc().id

      const merchant = restaurants[selectedMerchant]

      const data = {
        merchant_id: selectedMerchant,
        merchant_name: _.get(merchant, 'name', 'N/A'),
        branch_id: selectedBranch,
        branch_name: _.get(merchant, ['branches', selectedBranch, 'name'], 'N/A'),
        started_at: Number(startAt),
        ended_at: Number(endAt),
        discount_rate: Number(discountRate),
        region: authData.region,
        message_en: messageEn,
        message_kh: messageKh,
        minimum_amount: minimumAmount,
        ...(isCostSharing ? { cost_sharing: { company: companyRate, merchant: merchantRate } } : { cost_sharing: null }),
        ...(isSelectedItems && selectedItems.length > 0 ? { selected_items: selectedItems } : { selected_items: null }),
        ...(isSelectedItems && selectedItems.length > 0 && isDiscountOnItem && choices.length > 0
          ? { custom: this.generateCustomItems() }
          : { custom: null }),
      }

      if (action === 'edit') {
        await promotionRef.doc(promotionKey).update(data)
      } else {
        await promotionRef.doc(promotionKey).set(data)
      }

      this.setState({ saving: false })
      savePromotion({ ...data, key: promotionKey })
      onClose()
    } catch (error) {
      this.setState({ saving: false })
      alert(error.message || error)
    }
  }

  onNewChoiceClick = () => {
    const { choices } = this.state

    this.setState({ choices: choices.concat({}) })
  }

  onChoiceChange = (choice, index) => {
    const { choices } = this.state
    const choiceArray = Array.from(choices)
    choiceArray[Number(index)] = choice

    this.setState({ choices: choiceArray })
  }

  onMessageChange = (field, message) => {
    const textLimit = 58

    if (message.length <= textLimit) {
      return this.setState({ [field]: message })
    }

    return false
  }

  render() {
    const {
      startAt,
      endAt,
      discountRate,
      isCostSharing,
      selectedItems,
      isSelectedItems,
      isApplyToAllBranches,
      companyRate,
      merchantRate,
      selectedMerchant,
      selectedBranch,
      isDiscountOnItem,
      choices,
      saving,
      minimumAmount,
      messageEn,
      messageKh,
    } = this.state
    const textLimit = 58
    const { onClose, restaurants, action, promotions } = this.props

    const label = action === 'edit' ? 'Update' : 'Save'
    const costSharingDisabled = discountRate === 0

    return (
      <Modal open size="small" style={{ marginTop: 0 }}>
        <Header content="Add Promotion" />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form onSubmit={this.onSavePress}>
            {action === 'new' ? (
              <Form.Group widths="equal">
                <RestaurantsField
                  restaurants={restaurants}
                  onChange={value => this.setState({ selectedMerchant: value })}
                  value={selectedMerchant}
                />
                <Form.Field
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginTop: 20,
                    zIndex: 1,
                  }}
                >
                  <Button.Group size="medium">
                    <Button
                      as="a"
                      onClick={() => this.setState({ isApplyToAllBranches: false, selectedBranch: null })}
                      positive={!isApplyToAllBranches}
                    >
                      Apply to branch
                    </Button>
                    <Button.Or />
                    <Button
                      as="a"
                      onClick={() => this.setState({ isApplyToAllBranches: true })}
                      positive={isApplyToAllBranches}
                    >
                      Apply to all branches
                    </Button>
                  </Button.Group>
                </Form.Field>
              </Form.Group>
            ) : null}

            {!isApplyToAllBranches && action === 'new' && (
              <Form.Group widths="equal">
                <BranchesField
                  allBranches={this.listSelectedMerchantBranches()}
                  onChange={value => this.setState({ selectedBranch: value })}
                  promotions={promotions}
                  value={selectedBranch}
                />
              </Form.Group>
            )}
            <Form.Group widths="equal">
              <InputField
                label={`Front Store Message En (${textLimit - messageEn.length})`}
                value={messageEn}
                onChange={value => this.onMessageChange('messageEn', value )}
              />
              <InputField
                label={`Front Store Message Kh (${textLimit - messageKh.length})`}
                value={messageKh}
                onChange={value => this.onMessageChange('messageKh', value)}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <DateField
                label="Start Date"
                onChange={value =>
                  this.setState({
                    startAt: Number(
                      moment(value, 'YYYY-MM-DD')
                        .startOf('day')
                        .format('x')
                    ),
                  })
                }
                value={startAt}
              />
              <DateField
                label="End Date"
                onChange={value =>
                  this.setState({
                    endAt: Number(
                      moment(value, 'YYYY-MM-DD')
                        .endOf('day')
                        .format('x')
                    ),
                  })
                }
                value={endAt}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <DiscountField
                onChange={value => this.setState({ discountRate: Number(value) })}
                value={discountRate}
              />
              <Form.Field
                style={{ alignItems: 'center', display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}
              >
                <Checkbox
                  label="Share Expense"
                  checked={isCostSharing}
                  disabled={(action === 'new' && costSharingDisabled) || isDiscountOnItem}
                  onChange={this.onShareExpenseCheck}
                />
              </Form.Field>
            </Form.Group>

            {isCostSharing && (
              <Form.Group widths="equal">
                <ShareExpense
                  label="Company Rate"
                  onChange={value => this.onSharingExpenseChange('companyRate', value)}
                  value={companyRate}
                />
                <ShareExpense
                  label="Merchant Rate"
                  onChange={value => this.onSharingExpenseChange('merchantRate', value)}
                  value={merchantRate}
                />
              </Form.Group>
            )}
            <Form.Group widths="equal">
              <MinimumAmountField
                onChange={value => this.setState({ minimumAmount: Number(value) })}
                value={minimumAmount}
              />
            </Form.Group>
            {isSelectedItems && (
              <Form.Group widths="equal">
                <ItemField
                  data={this.listSelectedItems()}
                  itemKeys={selectedItems}
                  selectedRestaurant={selectedMerchant}
                  onChange={d => this.onItemsChange(d)}
                />
              </Form.Group>
            )}

            <Form.Group widths="equal" style={{ marginLeft: 5, marginTop: 10 }}>
              <Checkbox
                checked={isSelectedItems}
                label="Discount on selected items"
                disabled={selectedMerchant === null}
                onChange={() => this.setState({ isSelectedItems: !isSelectedItems })}
              />
            </Form.Group>

            <Form.Group widths="equal" style={{ marginLeft: 5, marginTop: 10 }}>
              <Checkbox
                checked={isDiscountOnItem}
                disabled={!isSelectedItems || selectedItems.length === 0 || isCostSharing}
                label="Custom discount rate on Item"
                onChange={() => this.setState({ isDiscountOnItem: !isDiscountOnItem })}
              />
            </Form.Group>

            {isDiscountOnItem ? (
              <Segment color="black" style={{ marginTop: 10 }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Header>Custom Item</Header>
                  <div>
                    <Button as="a" icon="add" onClick={this.onNewChoiceClick} />
                  </div>
                </div>
                {_.map(choices, (choice, index) => {
                  return (
                    <ChoiceForm
                      key={index}
                      action={action}
                      choice={choice}
                      items={this.listSelectedItems()}
                      onChange={nextChoice => this.onChoiceChange(nextChoice, index)}
                      onRemove={() =>
                        this.setState({
                          choices: choices.filter((_choice, choiceIndex) => index !== choiceIndex),
                        })
                      }
                    />
                  )
                })}
              </Segment>
            ) : null}

            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Close</Button>
          <Button
            icon
            color="black"
            loading={saving}
            disabled={saving}
            onClick={() => this.btnSubmitRef.click()}
          >
            <Icon name="checkmark" /> {label}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapSate = ({ items, auth, pickUpPromotions }) => ({
  promotions: pickUpPromotions.data,
  items: items.data,
  authData: auth.data,
})

const mapDispatch = {
  fetchItems: ItemActions.fetchItemsByRestaurant,
  savePromotion: PickUpPromotionActions.savePickUpPromotion,
}

export default connect(
  mapSate,
  mapDispatch
)(PromotionForm)



// WEBPACK FOOTER //
// ./src/components/pickUpPromotions/forms/promotionForm.js